import { QualificationInterface } from "../interfaces/QualificationInterface";
import { ValidityPeriodInterface } from "../interfaces/ValidityPeriodInterface";
import { QualificationValidityTypeEnum } from "../enums/QualificationValidityTypeEnum";

export interface QualificationFormValidityValues {
    selectedId: string;
    selectedValue: string;
    validityPeriod: ValidityPeriodInterface | null;
    validityType: QualificationValidityTypeEnum | null;
    fixedValidUntil: string | null;
}

export const getQualificationFormValidityValues = (
    qualification?: QualificationInterface | null,
): QualificationFormValidityValues => ({
    selectedId: qualification?.id?.toString() ?? "",
    selectedValue: qualification?.name ?? "",
    validityPeriod: qualification?.validity_period ?? null,
    validityType: qualification?.validity_type ?? null,
    fixedValidUntil: qualification?.fixed_valid_until ?? null,
});
